import { FC } from 'react';

type Props = {
	className?: string;
};

const CheckmarkIconSolid: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='#2B2B2B'
			stroke='none'
			className={className}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10ZM13.4796 7.21886C13.7825 7.49659 13.803 7.96734 13.5254 8.27031L9.43233 12.7354C9.29511 12.8851 9.10281 12.9721 8.89987 12.9766C8.69693 12.981 8.50103 12.9023 8.3575 12.7588L6.49703 10.8983C6.20641 10.6077 6.20641 10.1365 6.49703 9.84588C6.78766 9.55527 7.25885 9.55527 7.54948 9.84588L8.86035 11.1568L12.4281 7.26458C12.7059 6.96161 13.1766 6.94114 13.4796 7.21886Z'
				fill='inherit'
			/>
		</svg>
	);
};

export default CheckmarkIconSolid;
